var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f2cd35d0-3ed0-4419-ac09-330805abc73f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 118 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b0bb8d95-6716-499d-903b-ef04d08baa7b,.b4add71a-7ff8-4a4a-92c9-cd21e0d5f64c{fill:none;}.b8bc5fbf-ad1a-408f-9417-973930b74148{clip-path:url(#b2394e4b-484d-4df0-8e88-376e73e13d04);}.b7746282-09fc-4aba-b8d3-8fe6f879bfc5{clip-path:url(#e7bdd6d4-7382-4449-8d70-8d7c48acb9e0);}.bf48cafe-7ab6-40d2-900f-9e3f930bd231{fill:#ff4e61;}.b0bb8d95-6716-499d-903b-ef04d08baa7b{stroke:#fff;stroke-miterlimit:10;stroke-width:0.89px;}.b073402b-9b4f-4307-9c71-90e7a1e5859b{clip-path:url(#a93a1bb2-9001-449b-8535-b17029e26b0c);}.b968c679-6998-42a4-884f-ba42b3b3d3f5{fill:#fff;}.a8c5b7eb-eb8a-4a8f-9efd-d23fc90793f6{clip-path:url(#fedc55fa-5d53-4a9b-b943-66cbb64aa13c);}.af8dc995-a287-4564-b754-ad6fa8ab426e{clip-path:url(#ba16e140-3074-44a2-a65d-c498f44678cf);}.a05c5ed6-efd6-4e08-9971-a9aa57e9c856{clip-path:url(#aeb7ba82-9ccd-4d49-93da-a71b39aa25a5);}.bf9ce7a0-f452-4ac0-ba7f-127b23602120{clip-path:url(#ba9a6069-eca1-43c9-bd4e-771be2ba1810);}.e9668390-e7f4-464d-90a3-f4e927f15ad8{clip-path:url(#b9cfeae1-e575-4bde-8678-2c37c56dd35f);}.a80b3bd8-77e1-44b7-9624-63e83713dad0{clip-path:url(#e6a265f8-a678-4634-b68f-82077431d912);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2394e4b-484d-4df0-8e88-376e73e13d04"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b4add71a-7ff8-4a4a-92c9-cd21e0d5f64c",
    width: 118,
    height: 116
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7bdd6d4-7382-4449-8d70-8d7c48acb9e0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b4add71a-7ff8-4a4a-92c9-cd21e0d5f64c",
    cx: 59,
    cy: 58,
    r: 56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a93a1bb2-9001-449b-8535-b17029e26b0c"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b4add71a-7ff8-4a4a-92c9-cd21e0d5f64c",
    points: "34.91 47.19 36.88 52.6 42.93 50.4 40.96 44.99 44.02 43.87 48.98 57.49 45.92 58.6 43.92 53.11 37.87 55.31 39.87 60.81 36.84 61.91 31.88 48.29 34.91 47.19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fedc55fa-5d53-4a9b-b943-66cbb64aa13c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b4add71a-7ff8-4a4a-92c9-cd21e0d5f64c",
    d: "M54.09,40A7.46,7.46,0,1,1,59.2,54a7.46,7.46,0,1,1-5.11-14Zm1,2.7a4.27,4.27,0,0,0-2.52,5.8,4.35,4.35,0,1,0,8.16-3A4.25,4.25,0,0,0,55.08,42.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba16e140-3074-44a2-a65d-c498f44678cf"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b4add71a-7ff8-4a4a-92c9-cd21e0d5f64c",
    points: "74.28 32.86 75.26 35.57 71.22 37.04 75.19 47.95 72.16 49.05 68.19 38.14 64.13 39.62 63.14 36.91 74.28 32.86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aeb7ba82-9ccd-4d49-93da-a71b39aa25a5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b4add71a-7ff8-4a4a-92c9-cd21e0d5f64c",
    d: "M39.31,68.58A8.79,8.79,0,0,1,43.94,68l1.15,3.14-.15,0a6.23,6.23,0,0,0-4.69.06c-1.5.55-2.23,1.46-1.9,2.39.29.78,1,.91,3.12.4,3.73-.92,5.53-.18,6.48,2.42s-.42,5-3.9,6.25a9.44,9.44,0,0,1-5.5.66l-1.14-3.14.14-.05A8,8,0,0,0,43,80.09c1.66-.6,2.35-1.44,2-2.42-.3-.82-1.07-1-3.23-.43-3.65.89-5.42.21-6.33-2.29C34.41,72.22,35.87,69.83,39.31,68.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba9a6069-eca1-43c9-bd4e-771be2ba1810"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b4add71a-7ff8-4a4a-92c9-cd21e0d5f64c",
    d: "M54.72,63.2,65.48,74.71,62.22,75.9l-1.76-2-6.25,2.28-.09,2.63L50.94,80l.85-15.73Zm-.23,4h0l-.17,6,4.21-1.53Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b9cfeae1-e575-4bde-8678-2c37c56dd35f"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b4add71a-7ff8-4a4a-92c9-cd21e0d5f64c",
    points: "66.2 59.03 70.17 69.94 77.04 67.44 78.03 70.14 68.12 73.75 63.17 60.13 66.2 59.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e6a265f8-a678-4634-b68f-82077431d912"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b4add71a-7ff8-4a4a-92c9-cd21e0d5f64c",
    points: "86.15 51.77 87.14 54.47 79.98 57.08 81 59.89 86.68 57.82 87.61 60.36 81.93 62.43 82.96 65.28 90.12 62.67 91.11 65.38 80.91 69.09 75.96 55.47 86.15 51.77"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b8bc5fbf-ad1a-408f-9417-973930b74148"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b7746282-09fc-4aba-b8d3-8fe6f879bfc5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "bf48cafe-7ab6-40d2-900f-9e3f930bd231",
    points: "3 2 115 2 115 114 3 114 3 2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b0bb8d95-6716-499d-903b-ef04d08baa7b",
    d: "M59.41,107.51A49.11,49.11,0,1,0,10.3,58.41,49.11,49.11,0,0,0,59.41,107.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b073402b-9b4f-4307-9c71-90e7a1e5859b"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b968c679-6998-42a4-884f-ba42b3b3d3f5",
    points: "31.88 48.29 44.02 43.87 48.98 57.49 36.84 61.91 31.88 48.29"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a8c5b7eb-eb8a-4a8f-9efd-d23fc90793f6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b968c679-6998-42a4-884f-ba42b3b3d3f5",
    points: "46.93 42.58 61.25 37.37 66.35 51.4 52.04 56.61 46.93 42.58"
  })), /*#__PURE__*/React.createElement("g", {
    className: "af8dc995-a287-4564-b754-ad6fa8ab426e"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b968c679-6998-42a4-884f-ba42b3b3d3f5",
    points: "63.14 36.91 74.28 32.86 79.24 46.48 68.1 50.53 63.14 36.91"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a05c5ed6-efd6-4e08-9971-a9aa57e9c856"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b968c679-6998-42a4-884f-ba42b3b3d3f5",
    points: "33.81 70.58 44.4 66.73 49.5 80.76 38.92 84.61 33.81 70.58"
  })), /*#__PURE__*/React.createElement("g", {
    className: "bf9ce7a0-f452-4ac0-ba7f-127b23602120"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b968c679-6998-42a4-884f-ba42b3b3d3f5",
    points: "45.98 66.38 60.52 61.09 65.48 74.71 50.94 80 45.98 66.38"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e9668390-e7f4-464d-90a3-f4e927f15ad8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b968c679-6998-42a4-884f-ba42b3b3d3f5",
    points: "63.17 60.13 73.07 56.52 78.03 70.14 68.12 73.75 63.17 60.13"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a80b3bd8-77e1-44b7-9624-63e83713dad0"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b968c679-6998-42a4-884f-ba42b3b3d3f5",
    points: "75.96 55.47 86.15 51.77 91.11 65.38 80.91 69.09 75.96 55.47"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.7c3148b6d8101f9259e5f1e0ed2dd935.svg";
export { ForwardRef as ReactComponent };